// import React, { useState } from 'react';
// import i18next from 'i18next';
// import { Form } from 'react-bootstrap';
// import { useTranslation } from 'react-i18next';
// import Select from 'react-select';
// import { Icon } from '@iconify/react';

// const NtxLanguage = () => {
//   const { t } = useTranslation();

//   const [language, setLanguage] = useState(() => {
//     const storedLanguage = localStorage && localStorage.getItem('language');
//     return storedLanguage !== null ? storedLanguage : 'ar';
//   });

//   const SaveLanguage = () => {
//     localStorage.setItem('language', language);
//     i18next.changeLanguage(language);
//     setLanguage(language);

//     window.location.reload();

//     // document.documentElement.setAttribute('dir', language === 'ar' ? 'rtl' : '');

//     // document.documentElement.classList.add(language === 'ar' ? 'rtl' : 'ltr');
//   };

//   // const options = [
//   //   {
//   //     label: (
//   //       <div className="flex items-center gap-2">
//   //         <Icon icon="twemoji:flag-saudi-arabia" width="20" height="20" />{' '}
//   //         {/* أيقونة العلم السعودي */}
//   //         <span>العربية</span>
//   //       </div>
//   //     ),
//   //     value: 'ar',
//   //   },
//   //   {
//   //     label: (
//   //       <div className="flex items-center gap-2">
//   //         <Icon icon="twemoji:flag-united-kingdom" width="20" height="20" />{' '}
//   //         {/* أيقونة العلم البريطاني */}
//   //         <span>English</span>
//   //       </div>
//   //     ),
//   //     value: 'en',
//   //   },
//   //   {
//   //     label: (
//   //       <div className="flex items-center gap-2">
//   //         <Icon icon="twemoji:flag-turkey" width="20" height="20" /> {/* أيقونة العلم التركي */}
//   //         <span>Türkçe</span>
//   //       </div>
//   //     ),
//   //     value: 'tr',
//   //   },
//   // ];
//   return (
//     <>
//       <div className="col-xl-12">
//         <div className="form-group mb-3">
//           <label className="form-label">{t('ChooseLanguage')}</label>
//           <Form.Select
//             className="form-select"
//             name="Language"
//             value={language}
//             onChange={(e) => setLanguage(e.target.value)}>
//             <option value="en">English</option>
//             <option value="ar">العربية</option>
//           </Form.Select>
//         </div>
//       </div>
//       {/* <div className="col-xl-12">
//         <div className="form-group mb-3">
//           <label className="form-label">{t('ChooseLanguage')}</label>
//           <Select
//             classNamePrefix="react-select"
//             className="text-center w-100 custom-border"
//             isSearchable={false}
//             options={options}
//             // defaultValue={options.find((opt) => opt.value === currentLang)}
//             // onChange={handleSwitch}
//           />
//         </div>
//       </div> */}

//       <div className="text-center mt-4">
//         <div className="d-flex justify-content-between gap-2">
//           <button
//             type="button"
//             className="btn me-1 btn-theme mb-1 w-100"
//             onClick={() => SaveLanguage()}>
//             {false ? (
//               <div className="spinner-border spinner-border-sm me-2"></div>
//             ) : (
//               <i className="fa fa-save fa-fw me-1"></i>
//             )}
//             {t('Save')}
//           </button>
//           <button
//             type="button"
//             className=" btn me-1 btn-default mb-1 w-100"
//             data-bs-dismiss="modal"
//             id="closeModalForm">
//             <i className="fa fa-power-off fa-fw me-1"></i> {t('Cancel')}
//           </button>
//         </div>
//       </div>
//     </>
//   );
// };

// export default NtxLanguage;

import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import i18next from 'i18next';
import { Icon } from '@iconify/react';

const NtxLanguage = () => {
  const { t } = useTranslation();

  const storedLanguage = localStorage.getItem('language') || 'ar';
  const [language, setLanguage] = useState(storedLanguage);
  const [selectedLanguage, setSelectedLanguage] = useState(storedLanguage);

  // تحديث اتجاه الصفحة بناءً على اللغة المختارة
  useEffect(() => {
    document.documentElement.setAttribute('dir', language === 'ar' ? 'rtl' : 'ltr');
    document.documentElement.classList.toggle('rtl', language === 'ar');
    document.documentElement.classList.toggle('ltr', language !== 'ar');
  }, [language]);

  // تغيير اللغة مؤقتًا عند اختيارها من Select
  const handleLanguageChange = (selectedOption: any) => {
    setSelectedLanguage(selectedOption.value);
  };

  // تطبيق اللغة عند الضغط على زر "حفظ"
  const SaveLanguage = () => {
    localStorage.setItem('language', selectedLanguage);
    i18next.changeLanguage(selectedLanguage);
    setLanguage(selectedLanguage);
    window.location.reload(); // إعادة تحميل الصفحة لتطبيق التغييرات
  };

  const options = [
    {
      label: (
        <div className="d-flex align-items-center gap-2">
          <Icon icon="twemoji:flag-saudi-arabia" width="20" height="20" />
          <span>العربية</span>
        </div>
      ),
      value: 'ar',
    },
    {
      label: (
        <div className="d-flex align-items-center gap-2">
          <Icon icon="twemoji:flag-united-kingdom" width="20" height="20" />
          <span>English</span>
        </div>
      ),
      value: 'en',
    },
    {
      label: (
        <div className="d-flex align-items-center gap-2">
          <Icon icon="twemoji:flag-turkey" width="20" height="20" />
          <span>Türkçe</span>
        </div>
      ),
      value: 'tr',
    },
  ];

  return (
    <>
      <div className="col-xl-12">
        <div className="form-group mb-3">
          <label className="form-label">{t('ChooseLanguage')}</label>
          <Select
            classNamePrefix="react-select"
            className="text-center w-100 custom-border"
            isSearchable={false}
            options={options}
            value={options.find((opt) => opt.value === selectedLanguage)}
            onChange={handleLanguageChange}
          />
        </div>
      </div>

      <div className="text-center mt-4">
        <div className="d-flex justify-content-between gap-2">
          <button type="button" className="btn me-1 btn-theme mb-1 w-100" onClick={SaveLanguage}>
            <i className="fa fa-save fa-fw me-1"></i>
            {t('Save')}
          </button>
          <button
            type="button"
            className="btn me-1 btn-default mb-1 w-100"
            data-bs-dismiss="modal"
            id="closeModalForm">
            <i className="fa fa-power-off fa-fw me-1"></i> {t('Cancel')}
          </button>
        </div>
      </div>
    </>
  );
};

export default NtxLanguage;
